import { useUpdate } from '@refinedev/core';
import { TemplateSection, UploadedTemplate } from 'src/data-capture/hooks/templates/useTemplates';

type UpdateSectionWithInstruction = TemplateSection & {
  editMessage: string;
  editType: 'SECTION_INSTRUCTIONS' | 'SECTION_TEMPLATE_TEXT' | 'BOTH';
};

export type TemplateToUpdate = UploadedTemplate & {
  sections: TemplateSection[] | UpdateSectionWithInstruction[];
  previewClientId?: string | null;
  previewSectionId?: string | null;
};

export const useUpdateTemplate = () => {
  const { mutateAsync, isLoading } = useUpdate<UploadedTemplate>();

  const updateTemplate = async (companyId: string, templateToUpdate: TemplateToUpdate) => {
    const response = await mutateAsync({
      resource: `admin/companies/${companyId}/templates`,
      id: templateToUpdate.id,
      values: templateToUpdate,
    });

    return response.data;
  };

  return {
    updateTemplate,
    isLoading,
  };
};
